import React from "react";
import { Button, Typography } from "@mui/material";
import "../../../App.css";

const CategoryCard = ({ cardImage, cardTitle, categoryClick }) => {
  return (
    // <div
    //   className="home-category-card"
    //   style={{ border: "1px solid #0A64BC4D" }}
    //   onClick={() => categoryClick({ title: cardTitle, img: cardImage })}
    // >
    //   <img src={cardImage} style={{ height: "150px", width: "150px" }} />
    //   <Typography variant="subtitle1">{cardTitle}</Typography>
    // </div>
    <Button variant="outlined" startIcon={<cardImage />} className="home-category-card2" onClick={() => categoryClick({ title: cardTitle, img: cardImage })} >
    <img src={cardImage} style={{ height: "50px", width: "50px" }} />
    <Typography variant="subtitle1" className="ml-4 button-text">{cardTitle}</Typography>
</Button>
  );
};

export default CategoryCard;
